<template>
    <ProductComp />
</template>
<script>
import ProductComp from '@/components/product/ProductComp.vue';

    export default {
    components: { ProductComp }
}
</script>

<style scoped>
    
</style>